/**
 * @module cercaliagl/MapEventType
 */

/**
 * @type {Object.<string, string>}
 */
const MapEventType = {
  /**
   * Triggered after a map frame is rendered.
   * @api
   */
  POSTRENDER: 'postrender',

  /**
   * Triggered when the map starts moving.
   * @api
   */
  MOVESTART: 'movestart',

  /**
   * Triggered after the map is moved.
   * @api
   */
  MOVEEND: 'moveend',
  /**
   * Triggered after change baselayer
   * @api
   */
  BASELAYERCHANGE: 'changebaselayer',
  /**
   * Triggered after zoom end
   * @api
   */
  ZOOMEND: 'zoomend',
  /**
   * Triggered after rotation end
   * @api
   */
  ROTATIONEND: 'rotationend',
  /**
   * Triggered after pitch end
   * @api
   */
  PITCHEND: 'pitchend',
  /**
   * Triggered after map is ready
   * @api
   */
  READY: 'ready',
  /**
   * Triggered after change base layer
   * @api
   */
  BASELAYER_CHANGE: 'baselayer_change',
};

export default MapEventType;
